import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetUserNamesArrayModel, GetUserNamesModel } from "../../models/GetUserNamesModel";

const initialGetUserNameState: GetUserNamesArrayModel = {
    all_bdpocs: [],
    all_bdheads: [],
    all_sbuheads: [],
    all_sbgheads: []
}
const GetUserNameSlice = createSlice({
    name: 'GetUserName',
    initialState: initialGetUserNameState,
    reducers: {
        setAllBDPOCs(state, action: PayloadAction<GetUserNamesModel[]>) {
            state.all_bdpocs= action.payload;
        },
        setAllBDHeads(state, action: PayloadAction<GetUserNamesModel[]>) {
            state.all_bdheads= action.payload;
        },
        setAllSBUHeads(state, action: PayloadAction<GetUserNamesModel[]>) {
            state.all_sbuheads= action.payload;
        },
        setAllSBGHeads(state, action: PayloadAction<GetUserNamesModel[]>) {
            state.all_sbgheads= action.payload;
        }
    }
})
export default GetUserNameSlice;